/**
 * Authentication utility functions
 */

/**
 * Redirects to login page while preserving the current location for post-login redirect
 * @param {Function} navigate - React Router navigate function
 * @param {Object} location - Current location object from useLocation
 */
export const redirectToLogin = (navigate, location) => {
  // Create redirect parameter with current path and search params
  const currentPath = location.pathname + (location.search || '');
  const redirectParam = encodeURIComponent(currentPath);
  
  // Navigate to login with redirect parameter
  navigate(`/login?redirect=${redirectParam}`);
};

/**
 * Checks if user is authenticated and redirects to login if not
 * @param {string|null} accessToken - User's access token
 * @param {Function} navigate - React Router navigate function
 * @param {Object} location - Current location object from useLocation
 * @returns {boolean} - Returns true if user is authenticated, false if redirected to login
 */
export const requireAuth = (accessToken, navigate, location) => {
  if (!accessToken) {
    redirectToLogin(navigate, location);
    return false;
  }
  return true;
};
